import React from "react";
import { Link } from "react-router-dom";
import { Page } from "@/components/Layout";
import { useConsultModal } from "@/components/ConsultModal";
import { ArrowRight } from "@phosphor-icons/react";

const concerns = ["Anxiety", "Stress", "Depression", "Burnout", "Trauma", "PTSD", "Grief", "Relationships"];

export default function MentalWellbeing() {
  const { open: openConsult } = useConsultModal();
  return (
    <Page>
      <section className="md-section md-page-hero">
        <div className="md-container">
          <div className="md-label-eyebrow mb-4">Couch · Mental Wellbeing</div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif">Support for what feels <em>heavy</em> right now</h1>
          <p className="text-base mt-5 max-w-4xl mx-auto">
            Hurt, exhausted, anxious, disconnected, or simply not feeling like yourself? At MindDhara, you&apos;ll find a space to slow down, make sense of what you&apos;re experiencing, and move forward with support.
          </p>
        </div>
      </section>

      <section className="md-section">
        <div className="md-container max-w-4xl text-center">
          <div className="flex flex-wrap gap-2 justify-center">
            {concerns.map((c) => <span key={c} className="md-tag">{c}</span>)}
          </div>
          <div className="mt-10 flex flex-wrap gap-3 justify-center">
            <Link to="/therapists?source=wellbeing-cta" className="btn-primary" data-testid="wellbeing-browse-therapists">Browse Therapists <ArrowRight size={14} weight="bold" /></Link>
            <button onClick={openConsult} className="btn-outline" data-testid="wellbeing-free-consultation">Book a Free Consultation</button>
          </div>
        </div>
      </section>
    </Page>
  );
}
